import Stripe from 'stripe'

export default function calculateAmounts(
  currency = 'usd',
  price: Stripe.Price,
  quantity: number,
  coupon?: Stripe.Coupon
) {
  const currencyOptions = price.currency_options?.[currency]
  if (!currencyOptions) {
    return null
  }

  const tier = currencyOptions.tiers?.find((t) => t.up_to === null || t.up_to >= quantity)
  if (!tier) {
    return null
  }

  if (!tier.unit_amount) {
    return null
  }

  const total = tier.unit_amount * quantity
  const per_team = tier.unit_amount
  const max_price_per_team = currencyOptions.tiers?.[0]?.unit_amount

  let standard_discount = 0
  let standard_discount_percent = 0
  if (max_price_per_team && max_price_per_team !== per_team) {
    standard_discount = (max_price_per_team - per_team) * quantity
    standard_discount_percent = Math.round((1 - per_team / max_price_per_team) * 100)
  }

  let coupon_discount = 0
  let coupon_discount_percent = 0
  if (coupon?.percent_off) {
    coupon_discount_percent = coupon.percent_off
    coupon_discount = total * (coupon.percent_off / 100)
    coupon_discount = Math.round(Math.round(coupon_discount * 100) / 100)
  }

  return {
    total: total - coupon_discount,
    per_team,
    coupon_discount,
    standard_discount,
    standard_discount_percent,
    coupon_discount_percent,
    max_price: max_price_per_team,
  }
}
